import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { AudienceModule } from '@features/audience/audience.module';
import { AccordionsModule } from '@yourcause/common/accordion';
import { AddEditLevelModalComponent } from './add-edit-level-modal/add-edit-level-modal.component';
import { BulkWorkflowLevelAudienceModalComponent } from './bulk-workflow-level-audience-modal/bulk-workflow-level-audience-modal.component';
import { CanDeleteOrDisableLevelPipe } from './can-delete-or-disable-level.pipe';
import { ManageWorkflowLevelUsersModalComponent } from './manage-workflow-level-users-modal/manage-workflow-level-users-modal.component';
import { PermissionsDisplayPipe } from './permissions-display.pipe';
import { RoutingModalComponent } from './routing-modal/routing-modal.component';
import { ToggleWorkflowLevelModalComponent } from './toggle-workflow-level-modal/toggle-workflow-level-modal.component';
import { UsersAndRoutesComponent } from './users-and-routes/users-and-routes.component';
import { WorkflowAccordionComponent } from './workflow-accordion/workflow-accordion.component';
import { WorkflowDetailFlyoutComponent } from './workflow-detail-flyout/workflow-detail-flyout.component';
import { WorkflowDetailPageComponent } from './workflow-detail-page/workflow-detail-page.component';
import { WorkflowDetailsModalComponent } from './workflow-details-modal/workflow-details-modal.component';
import { WorkflowManagerModalComponent } from './workflow-manager-modal/workflow-manager-modal.component';
import { WorkflowManagersTableComponent } from './workflow-managers-table/workflow-managers-table.component';
import { WorkflowPageComponent } from './workflow-page/workflow-page.component';
import { WorkflowStructureComponent } from './workflow-structure/workflow-structure.component';

@NgModule({
  imports: [
    GCCoreModule,
    AudienceModule,
    AccordionsModule
  ],
  declarations: [
    WorkflowPageComponent,
    WorkflowAccordionComponent,
    UsersAndRoutesComponent,
    RoutingModalComponent,
    WorkflowStructureComponent,
    AddEditLevelModalComponent,
    WorkflowDetailPageComponent,
    WorkflowManagersTableComponent,
    WorkflowDetailsModalComponent,
    ManageWorkflowLevelUsersModalComponent,
    WorkflowManagerModalComponent,
    PermissionsDisplayPipe,
    CanDeleteOrDisableLevelPipe,
    ToggleWorkflowLevelModalComponent,
    WorkflowDetailFlyoutComponent,
    BulkWorkflowLevelAudienceModalComponent
  ],
  exports: [
    WorkflowAccordionComponent,
    PermissionsDisplayPipe,
    CanDeleteOrDisableLevelPipe
  ]
})
export class WorkflowModule { }
